'use strict';

module.exports = {
    DEFAULT: {
        autoWidth: true,
        loop: false,
        navElement: 'button type="button"',
        navText: ['<span class="sr-only">Previous</span><span aria-hidden="true">\u2039</span>', '<span class="sr-only">Next</span><span aria-hidden="true">\u203A</span>'],
        slideBy: '1',
        dots: false,
        responsive: {
            0: {
                nav: false,
                margin: 10
            },
            1200: {
                nav: true,
                margin: 26.3
            }
        }
    },
    SLIDE_PER_PAGE: {
        items: 1,
        loop: true,
        nav: true,
        navElement: 'button type="button"',
        navText: ['<span class="sr-only">Previous</span><span aria-hidden="true">\u2039</span>', '<span class="sr-only">Next</span><span aria-hidden="true">\u203A</span>'],
        slideBy: '1',
        dots: false,
        responsive: {
            0: {
                margin: 10
            },
            1200: {
                margin: 26.3
            }
        }
    }
};
